import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=2c94150f&"
import script from "./inbox.vue?vue&type=script&lang=js&"
export * from "./inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c94150f')) {
      api.createRecord('2c94150f', component.options)
    } else {
      api.reload('2c94150f', component.options)
    }
    module.hot.accept("./inbox.vue?vue&type=template&id=2c94150f&", function () {
      api.rerender('2c94150f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/inbox.vue"
export default component.exports